import { Field, Label, Switch } from '@headlessui/react'
import clsx from 'clsx'
import * as React from 'react'

import { CheckOutlinedIcon } from '@/components/icons/CheckOutlined'
import { RemoveFilledIcon } from '@/components/icons/RemoveFilled'
import { Icon } from '@/components/ui/icon'

import { InputCheckboxProps } from './type'

export const InputCheckbox = React.forwardRef<
  HTMLDivElement,
  InputCheckboxProps
>(
  ({
    id,
    disabled,
    checked,
    isIndeterminate,
    label,
    showLabel,
    enterIndex,
    tabIndex,
    handleChange,
    handleFocus,
    handleBlur,
  }) =>
    //ref
    {
      return (
        <Field
          id={id}
          as="div"
          className={clsx([
            'tw-flex tw-items-center tw-justify-start',
            'tw-cursor-pointer',
          ])}
        >
          <Switch
            as="div"
            checked={isIndeterminate ? false : checked}
            onChange={disabled ? () => {} : handleChange}
            onFocus={disabled ? () => {} : handleFocus}
            onBlur={disabled ? () => {} : handleBlur}
            className={clsx([
              'tw-h-5 tw-w-5',
              'tw-inline-flex tw-items-center tw-justify-center',
              'tw-rounded tw-bg-white',
              'tw-border-2 tw-border-solid ',
              'tw-outline-none',
              (isIndeterminate || checked) && '!tw-bg-primary-500',
              disabled
                ? [
                    'tw-cursor-not-allowed tw-opacity-70',
                    'tw-border-gray-400 focus:tw-ring-0',
                  ]
                : [
                    'tw-cursor-pointer',
                    'tw-border-primary-500 focus:tw-outline-none',
                  ],
            ])}
            data-enterindex={
              enterIndex ? (disabled ? -1 : tabIndex ?? 0) : null
            }
          >
            {checked && !disabled && (
              <Icon icon={CheckOutlinedIcon} size={'xl'} color={'white'} />
            )}
            {isIndeterminate && !disabled && (
              <Icon icon={RemoveFilledIcon} size={'xl'} color={'white'} />
            )}
            {disabled && (
              <Icon icon={RemoveFilledIcon} size={'xl'} color={'disabled'} />
            )}
          </Switch>
          <Label
            as="span"
            className={clsx([
              showLabel ? ['tw-ml-2', 'tw-text-sm'] : ['tw-sr-only'],
            ])}
          >
            {label}
          </Label>
        </Field>
      )
    }
)

InputCheckbox.displayName = 'InputCheckbox'
